///-------------------------------------------
///|                                         |
///|     Generated code, do not edit.        |
///|                                         |
///-------------------------------------------
  

///Description: signed 8-bit integer
export type i8 = number;

///Description: signed 16-bit integer
export type i16 = number;

///Description: signed 32-bit integer
export type i32 = number;

///Description: signed 64-bit integer
export type i64 = number;

///Description: signed 128-bit integer
export type i128 = string;

///Description: unsigned 8-bit integer
export type u8 = number;

///Description: unsigned 16-bit integer
export type u16 = number;

///Description: unsigned 32-bit integer
export type u32 = number;

///Description: unsigned 64-bit integer
export type u64 = number;

///Description: unsigned 128-bit integer
export type u128 = string;

///Description: unsigned size integer
export type usize = string;

///Description: 32-bit floating point number
export type f32 = number;

///Description: 64-bit floating point number
export type f64 = number;

///Description: boolean value
export type bool = boolean;

///Description: a UTF-8 encoded string
export type rs_string = string;

///Description: a Unicode scalar value
export type char = string;

///Description: Universally Unique Identifier
export type uuid = string;

///Description: a UTC timestamp with nanosecond precision
export type timestamp = string;

///Description: a length of time
export type duration = string;

///Description: A scaled decimal
export type decimal = number;

///Description: a globally unique symbol to ID an instrument
export type rs_symbol = symbol;

///Description: a blob of bytes
export type binary = Uint8Array;

///Description: The side of an order book
export enum BookSide {
 bid,
 ask,
}

///Description: Direction of a trade from the customer's perspective. Distinct from book_side (bid/ask) — `buy` means the customer receives the base asset and pays in quote; `sell` is the inverse.
export enum TradeSide {
 buy,
 sell,
}

///Description: Which leg of a spot booking — the customer trade or the dealer's LP hedge.
export enum Leg {
 client,
 lp,
}

///Description: The side of a prediction contract
export enum PredictionSide {
 yes,
 no,
}

///Description: Self-Match Prevention instruction (FIX Tag 2964)
export enum SelfMatchPreventionInstruction {
 cancel_aggressive,
 cancel_passive,
 cancel_aggressive_and_passive,
}

///Description: The action for a market data entry
export enum MdUpdateAction {
 new,
 change,
 delete,
 overlay,
}

///Description: The type of a market data entry
export enum MdEntryType {
 bid,
 ask,
 trade,
 index_price,
 closing_price,
 mark_price,
 open_interest,
 interest_rate,
 book_reset,
 funding_rate,
 estimated_settle_price,
 fixing_price,
}

///Description: Whether a settlement value is final or a theoretical estimate (FIX Tag 731)
export enum SettlPriceType {
 final,
 theoretical,
}

///Description: The type of a placed order
export enum OrderType {
 market,
 limit,
 stop_market,
 stop_limit,
 previously_quoted,
}

///Description: The execution type for a place order
export enum OrderExecutionType {
 new,
 done_for_day,
 canceled,
 replaced,
 pending_cancel,
 stopped,
 rejected,
 pending_new,
 expired,
 restated,
 pending_replace,
 trade,
 order_status,
 triggered,
}

///Description: The status of a place order
export enum OrderStatus {
 new,
 partially_filled,
 filled,
 done_for_day,
 canceled,
 pending_cancel,
 rejected,
 suspended,
 pending_new,
 expired,
 pending_replace,
}

///Description: Which channel's execution report represents an order's latest state
export enum ExecutionReportSource {
 order_entry,
 drop_copy,
}

///Description: The status of a place order
export enum TimeInForce {
 day,
 good_till_cancel,
 at_the_opening,
 immediate_or_cancel,
 fill_or_kill,
 good_till_crossing,
 good_till_date,
 at_the_close,
 good_through_crossing,
 at_crossing,
}

///Description: The strategy used to place an order
export enum OrderPlacementStrategy {
 direct_market_access,
 order_routing_system,
 quoting_system,
}

///Description: A list of strings
export type string_list = string[];

///Description: A list of decimals
export type decimal_list = number[];

///Description: A list of different types
// ***Failed trying to map a non primitive type untyped_list to a list***

///Description: An enum with many types
export type untyped_item = number | string | boolean;

///Description: Code to identify reason for a Business Message Reject <j> message.
export enum BusinessRejectReason {
 other,
 unknown_id,
 unknown_security,
 unsupported_message_type,
 application_not_available,
 conditionally_required_field_missing,
 not_authorized,
 deliver_to_firm_not_available_at_this_time,
}

///Description: Code to identify reason for a session-level Reject <3> message.
export enum SessionRejectReason {
 invalid_tag_number,
 required_tag_missing,
 tag_not_defined_for_this_message_type,
 undefined_tag,
 tag_specified_without_a_value,
 value_is_incorrect_for_this_tag,
 incorrect_data_format_for_value,
 decryption_problem,
 signature_89_problem,
 comp_id_problem,
 sendingtime_accuracy_problem,
 invalid_msg_type,
 xml_validation_error,
 tag_appears_more_then_once,
 tag_specified_out_of_required_order,
 repeating_group_fields_out_of_order,
 incorrect_num_in_group_count_for_repeating_group,
 non_data_value_include_field_delimiter,
}

///Description: High level reject category to help classify rejects
export enum SystemRejectCategory {
 brokerage_reject,
 venue_reject,
 rate_limit,
}

///Description: High level reject type to help classify rejects by order action type
export enum SystemRejectType {
 new,
 cancel,
 replace,
 status,
 mass_cancel,
 market_data,
 mass_status,
}

///Description: Code to identify reason for order rejection
export enum OrderRejectReason {
 broker_exchange_option,
 unknown_symbol,
 exchange_closed,
 order_exceeds_limit,
 too_late_to_enter,
 unknown_order,
 duplicate_order,
 duplicate_verbally_communicated_order,
 stale_order,
 trade_along_required,
 invalid_investor_id,
 unsupported_order_characteristic,
 surveillance_option,
 incorrect_quantity,
 incorrect_allocated_quantity,
 unknown_accounts,
 price_exceeds_current_price_band,
 invalid_price_increment,
 other,
}

///Description: Which request an order cancel reject is answering
export enum CxlRejResponseTo {
 order_cancel_request,
 order_cancel_replace_request,
}

///Description: Code to identify reason for an order cancel reject
export enum CxlRejReason {
 too_late_to_cancel,
 unknown_order,
 broker_exchange_option,
 order_already_in_pending_cancel_or_pending_replace_status,
 unable_to_process_order_mass_cancel_request,
 orig_ord_mod_time_did_not_match_last_transact_time,
 duplicate_clordid,
 price_exceeds_current_price,
 price_exceeds_current_price_band,
 invalid_price_increment,
 other,
}

///Description: Feed type for market data
export enum MarketDataFeedType {
 book,
 trade,
 bbo,
 open_interest,
 candle,
 mark_price,
 l3_book,
 candlert,
 quote,
}

///Description: Feed type for drop copy
export enum DropCopyFeedType {
 order_event,
 position_update,
 balance_update,
 asset_margin_report,
 position_margin_report,
 trade_event,
 transfer_event,
 account_update,
}

///Description: Subscription action
export enum SubscriptionAction {
 subscribe,
 unsubscribe,
}

///Description: Classifies a RequestResult failure so consumers can branch on the cause instead of matching error_message text
export enum RequestErrorReason {
 already_started,
 did_not_exist,
 already_enabled,
 throttled,
}

///Description: Login error kind
export enum LoginError {
 unknown_format,
 decoding,
}

///Description: Protocol
export enum Protocol {
 https,
 wss,
 http,
 ws,
 fix,
}

///Description: Code to identify reason for an ExecutionReport message sent with ExecType=Restated or used when communicating an unsolicited cancel.
export enum ExecRestatementReason {
 partial_decline,
}

///Description: Indicates type of miscellaneous fee.
export enum MiscFeeType {
 tax,
 local_commission,
 exchange_fees,
}

///Description: How a commission amount is expressed.
export enum CommType {
 per_unit,
 percent,
 absolute,
}

///Description: Whether an execution opens or closes a position.
export enum PositionEffect {
 open,
 close,
}

///Description: Whether an account is the customer or non-customer side of the books.
export enum AccountType {
 customer,
 non_customer,
}

///Description: Broker capacity in the execution (FIX tag 29 LastCapacity).
export enum LastCapacity {
 agent,
 cross_as_agent,
 cross_as_principal,
 principal,
 riskless_principal,
}

///Description: Capacity the order is placed in (FIX tag 528 OrderCapacity).
export enum OrderCapacity {
 agency,
 principal,
 riskless_principal,
}

///Description: Instructions for order handling
export enum ExecInst {
 post_only,
 do_not_increase,
 primary_peg,
}

///Description: Instructions for order handling on Broker trading floor
export enum HandlInst {
 automated_private,
 automated_public,
 manual,
}

///Description: Type of margin requirement report
export enum MarginReqmtRptType {
 summary,
 detail,
}

///Description: Type of margin requirement amount. Only initial_margin matches canonical FIX tag 1644; the other values are a Pulse-specific extension and do not carry their standard FIX meanings.
export enum MarginAmtType {
 maintenance_margin,
 initial_margin,
 margin_balance,
 unrealized_pnl,
 available_balance,
}

///Description: Used in position quantity block
export enum PosType {
 total_txn_quantity,
 net_delta_quantity,
}

///Description: Code to identify Mass Cancel Request Type.
export enum MassCancelRequestType {
 cancel_orders_for_a_security,
 cancel_orders_for_an_underlying_security,
 cancel_orders_for_a_product,
 cancel_orders_for_a_cficode,
 cancel_orders_for_a_security_type,
 cancel_orders_for_a_trading_session,
 cancel_all_orders,
 cancel_orders_for_a_market,
 cancel_orders_for_a_market_segment,
 cancel_orders_for_a_security_group,
 cancel_for_security_issuer,
 cancel_for_issuer_of_underlying_security,
}

///Description: Code to identify Mass Cancel Reject Reason.
export enum MassCancelRejectReason {
 mass_cancel_not_supported,
 invalid_or_unknown_security,
 invalid_or_unknown_underlying_security,
 invalid_or_unknown_product,
 invalid_or_unknown_cficode,
 invalid_or_unknown_security_type,
 invalid_or_unknown_trading_session,
 invalid_or_unknown_market,
 invalid_or_unknown_market_segment,
 invalid_or_unknown_security_group,
 invalid_or_unknown_security_issuer,
 invalid_or_unknown_issuer_of_underlying_security,
 other,
}

///Description: Code to identify Mass Cancel Response Type.
export enum MassCancelResponseType {
 cancel_request_rejected,
 cancel_orders_for_a_security,
 cancel_orders_for_an_underlying_security,
 cancel_orders_for_a_product,
 cancel_orders_for_a_cficode,
 cancel_orders_for_a_security_type,
 cancel_orders_for_a_trading_session,
 cancel_all_orders,
 cancel_orders_for_a_market,
 cancel_orders_for_a_market_segment,
 cancel_orders_for_a_security_group,
 cancel_orders_for_a_securities_issuer,
 cancel_orders_for_issuer_of_underlying_security,
}

///Description: Used to specify why an restatement is occurring
export enum RestatementReason {
 disconnect,
 reconnect,
 snapshot,
}

///Description: Event type that caused balance or position update
export enum PosEventType {
 withdraw,
 deposit,
 trade,
 snapshot,
 hold,
 release,
 update,
 net,
}

///Description: Indicates the reason a transfer was created
export enum TransferType {
 deposit,
 withdraw,
 transfer,
}

///Description: Asset type of a transfer
export enum TransferAsset {
 crypto,
 fiat,
}

///Description: Enabled feed types for a VenueApiKey
export enum VenueApiKeyFeedType {
 bbo,
 book,
 trade,
 order_event,
 position_update,
 balance_update,
 asset_margin_update,
 position_margin_update,
 open_interest,
 trade_event,
 transfer_event,
 account_update,
 l3_book,
 mark_price,
 candle,
 candlert,
 order_entry,
 request_for_quote,
 request_for_stream,
 executable_streaming_prices,
}

///Description: Identifies the type or role of the PartyID <448> specified
export enum PartyRole {
 executing_firm,
 exchange,
 customer_account,
 intermediary,
 liquidity_provider,
 entering_trader,
 executing_system,
 account_wallet,
 blockchain_wallet,
}

///Description: multi-venue use margin code
export enum MarginMode {
 cross,
 isolated,
 all,
 cash,
}

///Description: how the account pools collateral across assets
export enum CollateralMode {
 single_asset,
 multi_asset,
 portfolio_margin,
}

///Description: Indicates the status of a user
export enum UserStatus {
 logged_in,
 not_logged_in,
 user_not_recognized,
 password_incorrect,
 password_changed,
 other,
 forced_user_logout_by_exchange,
 session_shutdown_warning,
 throttle_parameters_changed,
 polling_started,
 uid_changed,
 exchange_error_response,
 validation_error,
}

///Description: Code to identify Mass Status Request Type.
export enum MassStatusReqType {
 status_orders_for_a_security,
 status_orders_for_an_underlying_security,
 status_orders_for_a_product,
 status_orders_for_a_cficode,
 status_orders_for_a_security_type,
 status_orders_for_a_trading_session,
 status_for_all_orders,
 status_for_orders_for_a_party_id,
 status_for_security_issuer,
 status_for_issuer_of_underlying_security,
 status_for_all_open_orders,
 status_for_all_closed_orders,
}

///Description: Timeseries feed variants
export enum TsVariant {
 dropcopy,
 mktdata,
 venue_account,
 quoting,
}

///Description: Timeseries feed variants
export enum TableType {
 log,
 snap,
}

///Description: Venue account product type
export enum VenueAccountFeedType {
 portfolio_asset,
 portfolio_position,
 portfolio_net,
 pnl_lifo,
 pnl_fifo,
 pnl_costaverage,
}

///Description: Different available venue api flags, can be used in a set
export enum VenueApiKeyFlag {
 derivs_api_key,
 position_only_pnl,
}

///Description: Indicates the status of a transfer
export enum TransferStatus {
 pending,
 complete,
 failed,
 canceled,
}

///Description: User role
export enum UserRole {
 viewer,
 admin,
 trader,
 account_manager,
 sales,
 risk,
 researcher,
 operations,
 sales_admin,
 trader_admin,
 operations_admin,
}

///Description: Different available asset flags, can be used in a set
export enum AssetFlag {
 pricing_unsupported,
 fiat,
 stable_coin,
}

///Description: Types of fix sessions that can be enabled
export enum FixSessionType {
 order_entry,
 drop_copy,
 market_data,
 quoting,
}

///Description: Serde Json Value
export type json_value = string;

///Description: Configuration for how to report message trace
export enum MessageTrace {
 disabled,
 log,
}

///Description: Quoting feed types
export enum QuotingFeedType {
 executable_streaming_prices,
 request_for_quote,
 request_for_stream,
}

///Description: Identifies the state of the quote
export enum QuoteStatus {
 accepted,
 rejected,
 completed,
 expired,
 cancelled,
}

///Description: Receive protocol used by service
export enum RcvType {
 http,
 ws,
 fix,
 shm,
}

///Description: Sequencer lifecycle events
export enum SequencerLifecycle {
 established,
 closed,
 heartbeat,
}

///Description: Feed type for derived market data
export enum DerivedMarketDataFeedType {
 bbo_by_notional,
 bbo_price_change,
}

///Description: indicator on current reliability of the associated field
export enum FieldStatus {
 ok,
 degraded,
}

///Description: Possible account status return values
export type account_status = string;

///Description: A book's hedgeable capacity — independent sided caps or pooled-margin facts
// ***Failed trying to map a non primitive type hedgeable_capacity***

///Description: Operation for tick size table
export enum TickSizeOp {
 greater,
 greater_or_equal,
 less,
 less_or_equal,
 equal,
}

///Description: The current state of a deployed feed
export enum FeedState {
 enabled,
 disabled,
 starting,
 connected,
 disconnected,
 degraded,
 polling,
 active,
}

///Description: How feed controllers learn feed liveness — by polling requests or from pushed events
export enum FeedStateMode {
 poll,
 event_driven,
}

///Description: A transport or membership transition for a feed, used to derive feed state
export enum LifecycleStatus {
 reconnected,
 disconnected,
 subscribed,
 unsubscribed,
 polling,
 degraded,
}

///Description: If the subscription is subscribed or unsubscribed
export enum SubscriptionState {
 subscribed,
 unsubscribed,
}

///Description: Market data subscription request type
export enum SubscriptionRequestType {
 subscribe,
 unsubscribe,
}

///Description: Market depth for market data request
export enum MarketDepth {
 full_book,
 top_of_book,
}

///Description: Market data update type
export enum MdUpdateType {
 full_refresh,
 incremental_refresh,
}

///Description: Market data request rejection reason
export enum MdReqRejReason {
 unknown_symbol,
 duplicate_md_req_id,
 request_not_supported,
 insufficient_permissions,
 stream_unavailable,
}

///Description: Status of a strategy instance
export enum StatusOfStrategyInstance {
 running,
 paused,
 stopped,
 starting,
 stopping,
 unknown,
}

///Description: The category of the order [quote_order, hedge_order]
export enum OrderCategory {
 quote_order,
 hedge_order,
}

///Description: The target strategy of the order
export enum TargetStrategy {
 vwap,
 participate,
 minimize_market_impact,
 twap,
}

///Description: Identifies the type of SecurityListRequest (FIX tag 559)
export enum SecurityListRequestType {
 symbol,
 security_type,
 product,
 trading_session_id,
 all_securities,
}

///Description: Result of a SecurityListRequest (FIX tag 560)
export enum SecurityRequestResult {
 valid_request,
 invalid_or_unsupported_request,
 no_instruments_found,
 not_authorized,
 instrument_data_temporarily_unavailable,
 request_for_instrument_data_not_supported,
}

///Description: Parent order lifecycle
export enum ParentState {
 accepted,
 working,
 completed,
 paused,
 resumed,
 rejected,
 cancelled,
 pending,
 timed_out,
}

///Description: OrderGuard drop causes; grouped under the order_guard service
export enum OrderGuardReason {
 reference_bbo_unavailable,
 quoting_bbo_unavailable,
 feed_unavailable,
 hedge_bbo_unavailable,
 hedge_feed_unavailable,
 unknown_quoter,
 other,
 account_report_pending,
}

///Description: PegPriceGuard drop causes; grouped under the peg_price_guard service
export enum PegPriceGuardReason {
 out_of_band,
 bbo_unavailable,
 other,
}

///Description: OrderShaper drop causes; grouped under the order_shaper service
export enum OrderShaperReason {
 redundant_cancel_replace,
 below_min_order_qty,
 min_order_qty_unavailable,
 other,
}

///Description: LimitTracker drop causes; grouped under the limit_tracker service
export enum LimitTrackerReason {
 trade_limit,
 reject_limit,
}

///Description: A throttle drop attributed to a service and its per-service reason
// ***Failed trying to map a non primitive type order_throttle***

///Description: The order-entry request kind that was dropped/decayed
export enum OrderThrottleEventType {
 new_order_single,
 order_cancel_request,
 order_cancel_replace_request,
 order_status_request,
 order_mass_cancel_request,
 order_mass_status_request,
}

///Description: The chain service that dropped/decayed the order
export enum OrderThrottleService {
 order_guard,
 peg_price_guard,
 order_shaper,
 system_startup,
 stop_strategy,
 limit_tracker,
 post_fill_cooldown,
 rate_limiter,
 opposite_side_live,
}

///Description: A health-relevant reason a quoter's orders are suppressed.
export enum HealthBlock {
 unavailable,
 rate_limited,
 trade_limited,
 lifecycle,
 fx_pending,
 fx_diverged,
 fx_ref_pending,
 fx_ref_diverged,
}

///Description: Why a quoter side's throttle elapsed; never a health block.
export enum QuoteRetryReason {
 post_fill_cooldown,
}

///Description: Selects the mid the OTC minimum-spread band is centred on
export enum BandAnchor {
 fair_value,
 consolidated_mid,
}

///Description: Selects which walk-derived price a FLATTEN hedge order's limit anchors to
export enum FlattenAnchor {
 tight,
 ceiling,
}

///Description: Which side of a live FX feed's BBO to read for a translation edge
export enum FxRateSide {
 directional,
 mid,
}

///Description: USD, or a USD-pegged stablecoin, used to denominate a Quantity notional
export enum StableCoin {
 USDT,
 USDC,
 FDUSD,
 BUSD,
 TUSD,
 USD,
}

///Description: Which fill channel first reported a lite fill
export enum FillOrigin {
 order_entry,
 order_event,
 trade_event,
}

///Description: The type of skew to apply
export enum SkewType {
 position,
 delta,
 liquidity,
 basis,
 basis_drift,
 momentum,
 bbo_divergence,
 funding_rate,
}

///Description: State of the client fill
export enum ClientFillState {
 unacked,
 acked,
 unknown,
}

